export enum Page {
  Schedule = 'schedule/',
  Schedule_Edit = 'schedule/edit/',
  Home = '',
  Rankings = 'rankings/',
  Standings = 'standings/',
  PhotoGalleries = 'media/photos/',
  PreviousSeasons = 'history/',
  Roster_AllTime = 'roster/all-time/',
  Roster_Edit = 'roster/edit/',
  Roster_BulkEdit = 'roster/bulk-edit/',
  Roster_QuickEdit = 'roster/quick-edit/',
  Roster_Print = 'roster/print/',
  Roster = 'roster/',
  Stats = 'stats/',
  Staff = 'staff/',
  Articles = 'media/news/',
  Videos = 'media/videos/',
  AdminDashboard = 'admin/',

  /* Retired react */
  // Parents = 'parents/',

  /* Not React pages */
  Calendar = 'calendar/',
  Coaches = 'staff/all-time/',
  GameHistory = 'schedule/all-time/'
}
